import React from "react";

import loadable from "@loadable/component";

const CarHistoryReportCheckout = loadable(() => import("../../../components/au.desktop/car-history-report-checkout"));
const CarHistoryReportPaymentSuccess = loadable(() => import("../../../components/au.desktop/car-history-report-payment-success"));
const CarHistoryReportPaymentFailed = loadable(() => import("../../../components/au.desktop/car-history-report-payment-failed"));
const CarHistoryPayment = loadable(() => import("../../../components/au.desktop/car-history-report-payment"));

const carHistoryReportSteps = {
    paymentSummary: {
        key: "paymentSummary",
        stepNo: 1,
        name: "Payment Summary",
        route: "payment-summary",
        defaultNext: "payment",
        defaultBack: "",
        isDisabled: false,
        type: "car-history-report",
        component: CarHistoryReportCheckout
    },
    payment: {
        key: "payment",
        stepNo: 1,
        name: "Payment",
        route: "payment",
        defaultNext: "my-report",
        defaultBack: "payment-summary",
        isDisabled: false,
        type: "car-history-report",
        component: CarHistoryPayment
    },
    paymentSuccess: {
        key: "paymentSuccess",
        stepNo: 2,
        name: "Payment Success",
        route: "my-report",
        defaultBack: "payment-summary",
        isDisabled: false,
        type: "car-history-report",
        component: CarHistoryReportPaymentSuccess
    },
    paymentFailed: {
        key: "paymentFailed",
        stepNo: 3,
        name: "Payment Failed",
        route: "payment-failed",
        defaultBack: "payment-summary",
        isDisabled: false,
        type: "car-history-report",
        component: CarHistoryReportPaymentFailed
    },
    carHistoryReportBookings: {
        key: "carHistoryReportBookings",
        stepNo: 4,
        name: "Car History Report Bookings",
        route: "bookings",
        defaultBack: "my-report",
        isDisabled: false,
        type: "car-history-report",
        component: CarHistoryReportPaymentFailed
    }
};

const carHistoryReportStepsArray = Object.values(carHistoryReportSteps);
const totalSteps = carHistoryReportStepsArray.length;

export {
    carHistoryReportSteps,
    carHistoryReportStepsArray,
    totalSteps
};
